import React, {
  useMemo, useEffect, useRef,
} from "react";
import Select from "react-select";
import {
  List,
} from "react-window";

function Row({ index, style, items }) {
  return <div style={style}>{items[index]}</div>;
}

const CustomMenuList = props => {
  const { options, children, getValue, maxHeight } = props;

  // children sicher in ein Array verwandeln (kann sonst null/undefined sein)
  const items = React.Children.toArray(children);

  const rowHeight = 35;
  const listHeight = Math.min(items.length * rowHeight, maxHeight ?? 300);

  // Ausgewählten Index robust ermitteln (nicht mit indexOf auf Objekt-Referenzen)
  const [selected] = getValue();
  const selectedIndex = options.findIndex(
    o => o?.value === selected?.value,
  );
  const initialOffset = Math.max(0, selectedIndex) * rowHeight;

  // Ref für die Liste
  const listRef = useRef(null);

  // Nach dem Mount scrollen
  useEffect(() => {
    if (listRef.current && initialOffset > 0) {
      listRef.current.scrollTo(initialOffset);
    }
  }, [initialOffset]);

  return (
    <List
      ref={listRef}
      rowComponent={Row}
      rowCount={items.length}
      rowHeight={rowHeight}
      // rowProps ist das Ersatz für "itemData"; immer ein Objekt übergeben:
      rowProps={{ items }}
      style={{ height: listHeight, width: "100%" }}
    />
  );
};

const VirtualizedSelect = ({ options, onChange, value, placeholder, ...props }) => {
  const memoizedOptions = useMemo(() => options, [options]);

  return (
    <Select
      options={memoizedOptions}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      components={{ MenuList: CustomMenuList }}
      // optional: Menü-Style ohne innere Scrollbar
      {...props}
    />
  );
};

export default VirtualizedSelect;
